import { NotesPage } from '@elsevier-health/osmosis-shared/types/notes';
import { track } from '../util/tracking';

/**
 * Downloads notes as a PDF file.
 */
export const downloadNotes = async (
  pages: NotesPage[],
  notesLink: string,
): Promise<void> => {
  let pdfUrl = formatUrl(pages[0]?.svg);
  if (pages[0].$) {
    pdfUrl = formatUrl(pages[0].$);
  }

  const pdfTitle = `${notesLink.replace(/_/g, ' ')}.pdf`;
  const file = await fetch(pdfUrl);
  const blob = await file.blob();
  const fileURL = globalThis.URL.createObjectURL(blob);

  const alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = pdfTitle;
  alink.click();

  track(
    'concept_card_interaction',
    {
      feature: 'learn-page-notes',
      interaction: 'download-notes',
    },
    ['keen'],
  );
};

const formatUrl = (url: string) => {
  return url.includes('assets')
    ? url.replace(/assets\/page-\d+\.svg$/, 'orig.pdf')
    : url.replace(/page-\d+\.svg$/, 'orig.pdf');
};
